import { ListaPerguntas } from 'api/DuvidasFrequentes';
import {
  AssemblyModalities,
  AssemblyModalitiesNumber,
  AssemblyStatus,
  LegacyStatus,
} from 'helpers/enums/Assembleia';
import {
  AssembleiaPautaStatus,
  AssembleiaTipoPauta,
  TipoVotoPauta,
} from 'helpers/enums/AssembleiaPautaStatus';
import {
  AssembleiaStatus,
  StatusMensagens,
} from 'helpers/enums/AssembleiaStatus';
import { TipoCargosChapa } from 'helpers/enums/TipoCargosChapa';
import {
  FlagColaborador,
  TipoColaborador,
} from 'helpers/enums/TipoColaborador';
import {
  AssembleiasAssociadoActionTypes,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_CLEARED_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO,
  ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE,
  ASSEMBLEIAS_ASSOCIADO_FLAG_PRESENCA_NAO_ONLINE,
  ASSEMBLEIAS_ASSOCIADO_FLAG_SEM_EMANCIPADO,
  ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
  ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA,
  ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION,
} from './AssembleiasAssociadoActionTypes';
import { AUTH_ACTIONS_LOGOUT, IAuthActionsLogout } from './AuthActionTypes';
import {
  WSAssembleiasActionTypes,
  WS_ASSEMBLEIAS_ACTIONS_OPEN,
} from './WSAssembleiasActionTypes';
import { IWSAssembleia } from './WSAssembleiasReducer';
export interface IAssembleiaContaAssociado {
  codigoAgencia: string;
  codigoCooperativa: string;
  cpfCnpj: string;
  cpfRepresentanteConfirmado: string;
  cpfRepresentanteLegal: string;
  idAssociado: number;
  idConvocado: number;
  nomeAssociado: string;
  numeroConta: string;
  numeroNucleo: string;
  presente: boolean;
  tipoPresenca: string;
  flgColaborador: FlagColaborador;
  flgExColaborador: boolean;
  tipoColaborador: TipoColaborador;
  flgTitular: boolean;
  dataPresenca?: null | string;
}

export interface IAssembleiaContasAssociado {
  assembleiaId: number;
  flagPresencaNaoOnline?: boolean;
  flagMenorSemEmancipado?: boolean;
  contas: IAssembleiaContaAssociado[];
}

export interface IAssembleiaAssociado {
  id: number;
  nome: string;
  descricao?: string;
  tipo: string;
  status: AssembleiaStatus;
}

type DateJSON = string;

export interface IAAssociadoEventoDocumento {
  desDocumento: string;
  dataCadastro: string | null;
  nomDocumento: string;
  oidDocumento: number;
  tipoDocumento: string;
}

export interface IEventosPorAssociado {
  dataEvento: string;
  dataEventoPresencial: string;
  flgConvocado: boolean;
  idEvento: number;
  nomeCoop: string;
  tipoEvento: string;
  situacaoOnlineEvento: AssemblyStatus;
  tituloEvento: string;
  dataFimEvento: string;
  dataFimEventoPresencial: string;
  situacao: LegacyStatus;
  cep: string | null;
  endereco: string | null;
  bairro: string | null;
  cidade: string | null;
  estado: string | null;
  modalidade: AssemblyModalities;
}

export interface IAAssociadoEventVideo {
  descricao: string;
  oidVideo: number;
  urlYoutube: string;
}

export interface IAssembleiaAssociadoPautaOpcao {
  descricao: string;
  flgAbstencao: number;
  idItemPauta: number;
  representantesChapa: IRepresentantesChapa[];
  ordem: number;
}

export interface IRepresentantesChapa {
  associado: string;
  idCargo: 0;
  idRepresentanteChapa: 0;
  nomeCargo: TipoCargosChapa;
}

export interface IAssembleiaAssociadoPautaVoto {
  cpfRepresentante: string;
  data: string;
  idConvocado: number;
  idEvento: number;
  idItemPauta: number;
  idPauta: number;
  tipo: number;
}

export interface IAssembleiaAssociadoPauta {
  codigoAgencia: string;
  titulo: string;
  descricao: string;
  idPauta: number;
  hasAnexos: boolean;
  itens: IAssembleiaAssociadoPautaOpcao[];
  numeroNucleo: string;
  ordem: number;
  estaVotadoPorOutroRepresentante: boolean;
  podeVotar?: boolean;
  status: AssembleiaPautaStatus;
  tempoVotacao: number;
  tempoRestante: number;
  tipoPauta: AssembleiaTipoPauta;
  votos: IAssembleiaAssociadoPautaVoto[];
  flgSecreta: boolean;
  flgRestrita: boolean;
  resultadoLiberado: boolean;
  resultadoLiberadoAssociado: boolean;
  resultadoLiberadoPresencial?: boolean;
  tipoVotoPauta: TipoVotoPauta;
  representante: string;
}

export interface IAssembleiaAssociadoEvento {
  bloqAlteraVoto: boolean;
  bloqChatMeuCad: boolean;
  bloqVotoMeuCad: boolean;
  cooperativa: string;
  dataBloqueio: DateJSON;
  dataCadastro: DateJSON;
  dataEvento: DateJSON;
  dataFim: DateJSON;
  descricao: string;
  documentos: IAAssociadoEventoDocumento[];
  id: number;
  nome: string;
  tipo: string;
  videos: IAAssociadoEventVideo[];
  contasDisponiveis?: IAssembleiaContaAssociado[];
  flagMenorSemEmancipado?: any;
  flagPresencaNaoOnline?: any;
  flagPesquisa?: boolean;
  urlTransmissao: string;
  pautas?: IAssembleiaAssociadoPauta[];
  flagMostrarAreaCoop: boolean;
  podeVotar?: boolean;
  presentes: number;
  usuariosLogados: number;
  contasCapital: number;
  status: AssembleiaStatus;
  statusChat: StatusMensagens;
  statusLegado: LegacyStatus;
  refreshedTimes: number;
  needLoadAssembleia: boolean;
  needLoadPautas: boolean;
  needLoadContas: boolean;
  ocultarNomeChat: boolean | null;
  modoEvento: AssemblyModalities;
  needCheckVote: boolean;
  userCanVote: boolean;
}

export interface IAssembleiasAssociadoDuvidas {
  usuario: ListaPerguntas;
  publica: ListaPerguntas;
}

export interface IAssembleiasAssociadoReducer {
  loadingAll: boolean;
  all: IEventosPorAssociado[];
  needLoadAll: boolean;
  loadingEvent: boolean;
  currentEvent: IAssembleiaAssociadoEvento | null;
  downloadindDocument: number[];
  downloadSuccessfully: number[];
  loadingContas: boolean;
  loadingPautas: boolean;
  consultaByCpfCnpj: IAssembleiaConsultaByCpfCnpj[];
  loadingConsultaByCpfCnpj: boolean;
  loadingDuvidas: boolean;
  duvidas: ListaPerguntas | null;
  loadingRespostaPauta: boolean;
  respostaPauta: IAssembleiaAssociadoRespostaPauta | null;
}

export interface IAssembleiaConsultaByCpfCnpj {
  oidEvento: number;
  idModo: AssemblyModalitiesNumber;
  titulo: string;
  descricao: string;
  bairro: string;
  cep: string;
  cidade: string;
  codigoCooperativa: string;
  codigoAgencia: string;
  nucleo: string;
  dataInicioEvento: DateJSON;
  dataFimEvento: DateJSON;
  dataInicioEventoOnline?: DateJSON;
  dataFimEventoOnline?: DateJSON;
  endereco: string;
  estado: string;
  modeloEvento: number;
  nomeCooperativa: string;
  referencia?: string;
}

export interface IAssembleiaAssociadoRespostaPauta {
  agencias: IRespostaPautaAgencias[];
  descricao: string;
  idPauta: number;
  titulo: string;
}

export interface IRespostaPautaAgencias {
  codigoAgencia: string;
  nucleos: IRespostaPautaAgenciasNucleos[];
}

export interface IRespostaPautaAgenciasNucleos {
  itens: IRespostaPautaAgenciaNucleosItens[];
  numeroNucleo: string;
  presentes: number;
  associadoLogadoisConvocado: boolean;
}

export interface IRespostaPautaAgenciaNucleosItens {
  abstencao: boolean;
  descricao: string;
  idItemPauta: number;
  percentual: number;
  votos: number;
}

const INITIAL_STATE: IAssembleiasAssociadoReducer = {
  loadingAll: false,
  all: [],
  needLoadAll: true,
  loadingEvent: false,
  currentEvent: null,
  downloadindDocument: [],
  downloadSuccessfully: [],
  loadingContas: false,
  loadingPautas: false,
  consultaByCpfCnpj: [],
  loadingConsultaByCpfCnpj: false,
  loadingDuvidas: false,
  duvidas: null,
  loadingRespostaPauta: false,
  respostaPauta: null,
};

const getAssembleiaEventoComPautas = (
  state: IAssembleiasAssociadoReducer,
  assembleiaId: number,
  pautasPorAssembleia: IAssembleiaAssociadoPauta[]
): IAssembleiaAssociadoEvento | null => {
  if (state.currentEvent && state.currentEvent.id === assembleiaId) {
    state.currentEvent.pautas = pautasPorAssembleia;
    state.currentEvent.refreshedTimes = state.currentEvent.refreshedTimes + 1;
    return state.currentEvent;
  }
  return null;
};

const getAssembleiaEventoComContas = (
  state: IAssembleiasAssociadoReducer,
  contasPorAssembleia: IAssembleiaContasAssociado
): IAssembleiaAssociadoEvento | null => {
  if (
    state.currentEvent &&
    state.currentEvent.id === contasPorAssembleia.assembleiaId
  ) {
    state.currentEvent.contasDisponiveis = contasPorAssembleia.contas;
    state.currentEvent.refreshedTimes = state.currentEvent.refreshedTimes + 1;
    return state.currentEvent;
  }
  return null;
};

const getRefreshedState = (
  state: IAssembleiasAssociadoReducer,
  assembleia: IWSAssembleia
): IAssembleiasAssociadoReducer => {
  const newState: IAssembleiasAssociadoReducer = { ...state };
  if (
    newState.currentEvent &&
    (newState.currentEvent.id === assembleia.id ||
      newState.currentEvent.id === assembleia.idPauta)
  ) {
    newState.currentEvent = {
      ...newState.currentEvent,
      refreshedTimes: newState.currentEvent.refreshedTimes + 1,
      contasCapital:
        typeof assembleia.contasCapital === 'number'
          ? assembleia.contasCapital
          : newState.currentEvent.contasCapital,
      // usuariosLogados:
      //   typeof assembleia.usuariosLogados === 'number'
      //     ? assembleia.usuariosLogados
      //     : newState.currentEvent.usuariosLogados,
      status:
        typeof assembleia.status === 'number'
          ? assembleia.status
          : newState.currentEvent.status,
      needLoadPautas:
        typeof assembleia.needLoadPautas === 'boolean'
          ? assembleia.needLoadPautas
          : false,
      needLoadContas:
        typeof assembleia.needLoadContas === 'boolean'
          ? assembleia.needLoadContas
          : false,
      statusChat:
        typeof assembleia.statusChat === 'number'
          ? assembleia.statusChat
          : newState.currentEvent.statusChat,
      needCheckVote:
        typeof assembleia.needLoadQuorum === 'boolean'
          ? assembleia.needLoadQuorum
          : newState.currentEvent.needCheckVote,
      pautas: newState.currentEvent.pautas
        ? newState.currentEvent.pautas.map((pauta) => {
            const filteredRefreshedPautas = assembleia.pautas
              ? assembleia.pautas.filter(
                  (pautaRefreshed) => pautaRefreshed.idPauta === pauta.idPauta
                )
              : [];
            if (filteredRefreshedPautas.length > 0) {
              return {
                ...pauta,
                status:
                  typeof filteredRefreshedPautas[0].status === 'number'
                    ? filteredRefreshedPautas[0].status
                    : pauta.status,
                tempoRestante:
                  filteredRefreshedPautas[0].tempoRestante ||
                  pauta.tempoRestante,
                tempoVotacao:
                  filteredRefreshedPautas[0].tempoVotacao || pauta.tempoVotacao,
                resultadoLiberado:
                  filteredRefreshedPautas[0].resultadoLiberado !== null
                    ? filteredRefreshedPautas[0].resultadoLiberado
                    : pauta.resultadoLiberado,
                resultadoLiberadoAssociado:
                  filteredRefreshedPautas[0].resultadoLiberadoAssociado !== null
                    ? filteredRefreshedPautas[0].resultadoLiberadoAssociado
                    : pauta.resultadoLiberadoAssociado,
                votos: filteredRefreshedPautas[0].votos || pauta.votos,
              };
            }
            return pauta;
          })
        : [],
      dataEvento:
        typeof assembleia.data === 'string'
          ? assembleia.data
          : newState.currentEvent.dataEvento,
      nome:
        typeof assembleia.titulo === 'string'
          ? assembleia.titulo
          : newState.currentEvent.nome,
      urlTransmissao:
        typeof assembleia.urlTransmissao === 'string'
          ? assembleia.urlTransmissao
          : newState.currentEvent.urlTransmissao,
    };
  }
  if (newState.all && newState.all.length > 0) {
    newState.all = newState.all.map((evento) => {
      if (
        evento.idEvento === assembleia.id ||
        evento.idEvento === assembleia.idPauta
      ) {
        return {
          ...evento,
          status:
            typeof assembleia.status === 'number'
              ? assembleia.status
              : evento.situacaoOnlineEvento,
        };
      }
      return evento;
    });
  }
  return newState;
};

const getContasComPresenca = (
  state: IAssembleiasAssociadoReducer,
  cpfCnpj: string,
  idsConvocados: number[],
  assembleiaId: number
): IAssembleiaContasAssociado => {
  let contas = [
    ...(state.currentEvent && state.currentEvent.contasDisponiveis
      ? state.currentEvent.contasDisponiveis
      : []),
  ];
  contas = contas.map(
    (conta: IAssembleiaContaAssociado): IAssembleiaContaAssociado => {
      const presente: boolean =
        !conta.presente && idsConvocados.indexOf(conta.idConvocado) > -1;
      return {
        ...conta,
        cpfRepresentanteConfirmado: !conta.presente
          ? cpfCnpj
          : conta.cpfRepresentanteConfirmado,
        presente: !conta.presente ? presente : conta.presente,
      };
    }
  );
  return {
    assembleiaId: assembleiaId,
    contas: contas,
  };
};

export default function AssembleiasAssociadoReducer(
  state: IAssembleiasAssociadoReducer = INITIAL_STATE,
  action:
    | AssembleiasAssociadoActionTypes
    | WSAssembleiasActionTypes
    | IAuthActionsLogout
) {
  switch (action.type) {
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA:
      const eventoComContasPresentes: IAssembleiaAssociadoEvento | null =
        getAssembleiaEventoComContas(
          state,
          getContasComPresenca(
            state,
            action.payload.cpfCnpj,
            action.payload.idsConvocados,
            action.payload.assembleiaId
          )
        );
      if (eventoComContasPresentes) {
        return { ...state, currentEvent: eventoComContasPresentes };
      }
      return state;
    case WS_ASSEMBLEIAS_ACTIONS_OPEN:
      return {
        ...state,
        needLoadAll: true,
        currentEvent: state.currentEvent
          ? {
              ...state.currentEvent,
              needLoadAssembleia: true,
            }
          : state.currentEvent,
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH:
      return getRefreshedState(state, action.payload);
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS:
      return {
        ...state,
        loadingPautas: action.payload,
        currentEvent: { ...state.currentEvent, needLoadPautas: false },
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS:
      const eventoComPautas: IAssembleiaAssociadoEvento | null =
        getAssembleiaEventoComPautas(
          state,
          action.assembleiaId,
          action.payload
        );
      if (eventoComPautas) {
        return { ...state, currentEvent: eventoComPautas };
      }
      return state;
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS:
      return {
        ...state,
        loadingContas: action.payload,
        currentEvent: { ...state.currentEvent, needLoadContas: false },
      };
    case ASSEMBLEIAS_ASSOCIADO_FLAG_SEM_EMANCIPADO:
      return {
        ...state,
        currentEvent: {
          ...state.currentEvent,
          flagMenorSemEmancipado: action.payload,
        },
      };
    case ASSEMBLEIAS_ASSOCIADO_FLAG_PRESENCA_NAO_ONLINE:
      return {
        ...state,
        currentEvent: {
          ...state.currentEvent,
          flagPresencaNaoOnline: action.payload,
        },
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS:
      const eventoComContas: IAssembleiaAssociadoEvento | null =
        getAssembleiaEventoComContas(state, action.payload);
      if (eventoComContas) {
        return { ...state, currentEvent: eventoComContas };
      }
      return state;
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL:
      return { ...state, loadingAll: action.payload, needLoadAll: false };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL:
      return { ...state, all: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT:
      return { ...state, currentEvent: null };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT:
      return {
        ...state,
        loadingEvent: action.payload,
        currentEvent: {
          ...state.currentEvent,
          needLoadAssembleia: false,
        },
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_CLEARED_EVENT:
      return {
        ...state,
        loadingEvent: false,
        currentEvent: undefined,
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT:
      return {
        ...state,
        currentEvent: {
          ...state.currentEvent,
          ...action.payload,
          contasDisponiveis: undefined,
          flagMenorSemEmancipado: undefined,
          flagPresencaNaoOnline: undefined,
          pautas: undefined,
          refreshedTimes: 0,
          needLoadContas: true,
          needLoadPautas: true,
          needCheckVote: true,
        },
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE:
      return { ...state, downloadindDocument: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS:
      return { ...state, downloadSuccessfully: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ:
      return { ...state, loadingConsultaByCpfCnpj: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ:
      return {
        ...state,
        consultaByCpfCnpj: action.payload,
      };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS:
      return { ...state, loadingDuvidas: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS:
      return { ...state, duvidas: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA:
      return { ...state, loadingRespostaPauta: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA:
      return { ...state, respostaPauta: action.payload };
    case ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO:
      return {
        ...state,
        currentEvent: {
          ...(state.currentEvent || {}),
          pautas: action.payload,
        },
      };
    case ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION:
      return {
        ...state,
        currentEvent: {
          ...state.currentEvent,
          needCheckVote: false,
          userCanVote: action.payload,
        },
      };
    case AUTH_ACTIONS_LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
